import { VabsPaymentDirection } from '@/shared/api';
import { ArrowUpRight, TopUpIcon } from '@/shared/assets';

import { TransactionsTypesFilterItem } from '../model/types';

export const transactionsTypeFilterItems: TransactionsTypesFilterItem[] = [
  {
    id: 'send',
    value: 'Send',
    type: VabsPaymentDirection.Outgoing,
    icon: <ArrowUpRight />,
  },
  {
    id: 'top-up',
    value: 'Top-up',
    type: VabsPaymentDirection.Incoming,
    icon: <TopUpIcon />,
  },
  // {
  //   id: 'exchange',
  //   value: 'Exchange',
  //   type: 'exchange',
  //   icon: <ExchangeIcon />,
  // },
  // {
  //   id: 'card-payment',
  //   value: 'Card payment',
  //   type: 'card-payment',
  //   icon: <CardOutline />,
  // },
];
